import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    let titleStr = `General Foreman`;
    if (!environment.production) {
      //non-prod environments get the environment name appended to the title
      titleStr += ` | ${environment.environmentName.toUpperCase()}`;
    }

    //Add the current route title
    const routeTitle = this.buildTitle(routerState);
    if (routeTitle !== undefined) {
      titleStr += ` > ${routeTitle}`;
    }

    this.title.setTitle(titleStr);
  }
}
